import { Fragment } from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
const override = {
  display: "block",
  margin: "0 auto",
};

const Loader = () => {
  return (
    <Fragment>
      <Backdrop
        sx={{ color: "#1b1b1b", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={true}
      >
        <CircularProgress sx={{ color: "primary.main" }} />
      </Backdrop>
    </Fragment>
  );
};

export default Loader;
